import axios from 'axios';
import { API_RESULT_CD, CommonResult, createApiRequestUrl, OK } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

export interface ProhibitedWordInfo {
  prohibitedWordId: number;
  prohibitedWord: string;
  effectiveDateFrom: string;
  effectiveDateTo: string;
  remarks: string;
  createByUserId: string;
  createYmdt: string;
  updateByUserId: string;
  updateYmdt: string;
  isProhibitedChar: boolean;
}

export interface MasterProhibitedWordGetApiResponse {
  result: CommonResult;
  prohibitedWordMstList: Array<ProhibitedWordInfo>;
}

/*
 * バックエンドからキャッシュされている禁則ワード一覧を取得
 */
export const masterApiGetAllProhibitedWord = async (): Promise<MasterProhibitedWordGetApiResponse> => {
  try {
    const URL = createApiRequestUrl('master/prohibitedWord');
    const response = await axios.get<MasterProhibitedWordGetApiResponse>(URL);
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
        return data;
      default:
        throw response;
    }
  } catch (error) {
    return {
      prohibitedWordMstList: [],
      result: {
        jobDateTime: '',
        resultCd: API_RESULT_CD.ERROR,
        resultMessageDtoList: [
          {
            resultMessageCd: API_RESULT_CD.ERROR,
            resultMessage: `${API_EXCEPTION_MSG}`,
          },
        ],
      },
    };
  }
};
